export default __webpack_public_path__ + "static/header-postgre-ecf1a6fce9d81fc9f3490f81f1ba3d86.jpg";